export const getPaginationOrder = (order, stateOrder) => {
  return order === "ascend"
    ? 1
    : order === "descend"
    ? -1
    : order === "reset"
    ? ""
    : !order
    ? 1
    : stateOrder === "ascend"
    ? 1
    : stateOrder === "descend"
    ? -1
    : stateOrder === "reset"
    ? ""
    : "";
};

export const getPageNo = (pageIdx, pageLimit, params) => {
  return +params?.page === 1 || !params?.page
    ? pageIdx + 1
    : (+params?.page - 1 >= 1 ? +params?.page - 1 : 1) *
        (pageLimit ? pageLimit : 10) +
        (pageIdx + 1);
};

export const isOnlyAlphabet = (val) => {
  let regex = /^[a-zA-Z_ ]*$/;
  if (regex.test(val)) {
    return true;
  } else {
    return false;
  }
};

export const randomColors1 = [
  "#0088FE",
  "#00C49F",
  "#FFBB28",
  "#FF8042",
  "#0952a3",
  "#03e81d",
  "#0404d2",
  "#0c480f",
  "#008893",
  "#0a7a7d",
  "#08cc86",
  "#096c9b",
  "#0aafe8",
  "#01eaa0",
  "#0424dd",
  "#02e9b7",
  "#0ad716",
  "#09c66b",
  "#072fac",
  "#096a60",
  "#0c0d2f",
  "#0dabdf",
  "#08b9c1",
  "#0955be",
  "#027d6f",
  "#0243aa",
  "#02780b",
  "#098294",
  "#0be115",
  "#04063f",
  "#092a0d",
  "#0655da",
  "#04b9d5",
  "#0d5090",
  "#0307a7",
  "#02de0e",
  "#0a85c8",
  "#04bee9",
  "#0c0e84",
  "#026db6",
  "#07440d",
  "#0e1ffb",
  "#006c12",
  "#057d0b",
];
export const randomColors2 = [
  "#FFBB28",
  "#FF8042",
  "#047c9d",
  "#023638",
  "#060575",
  "#0bf41b",
  "#0b3c03",
  "#00be52",
  "#031ab8",
  "#08dfcf",
  "#02ade4",
  "#0542ed",
  "#0768d8",
  "#0cf3a5",
  "#032d11",
  "#0a8c23",
  "#0161b5",
  "#04ebbc",
  "#096cd7",
  "#06fc5d",
  "#03a037",
  "#0ec2a8",
  "#003d6f",
  "#0487e9",
  "#016f51",
  "#00f775",
  "#082466",
  "#0b3f44",
  "#042e6f",
  "#09a5cd",
  "#06ead4",
  "#0e6379",
  "#08fb38",
  "#00bfdb",
  "#052939",
  "#02c8a5",
  "#05161a",
  "#01516e",
  "#072b4d",
  "#0abc3b",
  "#052d7b",
  "#0b74f2",
  "#0daa26",
  "#02c061",
  "#00f661",
  "#0aec71",
  "#0d5c0e",
  "#07872b",
  "#05826e",
  "#03483a",
  "#0a7721",
  "#0aa877",
];

export const isValidPassword = (val) => {
  let regx = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,99}$/;
  if (regx.test(val)) {
    return true;
  } else {
    return false;
  }
};

export const assetTypes = {
  mainSignal: "Main Signal",
  shuntSignal: "Shunt Signal",
  cOnSignal: "C-On Signal",
  routeSignal: "Route Signal",
  trackCircuit: "Track Circuit",
  point: "Point",
  axleCounter: "Axle Counter",
  msdac: "MSDAC",
  batteryBank: "Battery Bank",
  ips: "IPS",
  lcGate: "LC Gate",
  axleCounterResetBox: "Axle Counter Reset Box",
  others: "Others",
  motor: "Motor",
};

export const grpTypes = {
  main: "Main",
  sub: "Sub",
};

export const createArrayOf = (length, element = 1) => {
  const array = [];
  for (let i = 0; i < length; i++) {
    array.push(element);
  }
  return array;
};

export const widgetTypes = {
  text: "Text",
  lineGraph: "Line Graph",
  gauge: "Gauge",
  switch: "Switch",
  coordinates: "Coordinates",
  deviceStatus: "Device Status",
  hidden: "Hidden",
};

export const renderParamValue = (value) => (
  <div
    style={{
      color:
        {
          alert: "red",
          warning: "orange",
        }[value?.split("--alertType--")?.[1]] || "green",
    }}
  >
    {value?.split("--alertType--")?.[0]}
  </div>
);

export const userRole = () => {
  return JSON.parse(localStorage.user || {})?.role;
};

export const fallBackImage = () => {
  return "data:image/png;base64,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";
};
